export default "__VITE_ASSET__Bi4e6J0e__"